import Vue from 'vue'

const state = {
  isFetching: false,
  discounts: null
}

const actions = {
  LOAD_DISCOUNT_LIST: ({commit}, id) => {
    commit('REQUEST_DISCOUNT_LIST')
    const url = `users/${id}/reviews-discounts`
    Vue.http.get(url)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          commit('SET_DISCOUNT_LIST', response)
        }
      })
  }
}

const mutations = {
  REQUEST_DISCOUNT_LIST: state => {
    state.isFetching = true
  },
  SET_DISCOUNT_LIST: (state, discounts) => {
    state.isFetching = false
    state.discounts = discounts
  }
}

const getters = {
  getState: state => {
    return state
  },
  getDiscounts: state => {
    return state.discounts
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/discount.js